module.exports = __webpack_public_path__ + "img/potato-broccoli-bake.022d6324.jpg";